export enum FilterType {
    Premium = 'premium',
    Suggestion = 'suggestion',
}